import React from 'react';
import PropTypes from 'prop-types';
import {useTecRmiComponentTopics} from "../../../contexts/TecRmiComponentTopicsContext";
import Link from "../../Application/Link";
import appUserRoutes from "../../../appUserRoutes";
import {useTecRmi} from "../../../contexts/TecRmiContext";
import {ListGroup} from "reactstrap";
import {BreadcrumbsItem} from "react-breadcrumbs-dynamic";

const ComponentMainGroup = props => {
  const { typeId, ident } = useTecRmi()
  const componentTopics = useTecRmiComponentTopics()
  const mainGroupId = parseInt(props.match.params.mainGroupId)
  const componentTopic = componentTopics.find(componentTopic => componentTopic.MaingroupId === mainGroupId)

  return (
    <React.Fragment>
      <BreadcrumbsItem to={appUserRoutes.tecRmi.tabComponentMainGroup(ident, componentTopic.MaingroupId)}>{componentTopic.MaingroupText}</BreadcrumbsItem>
      <ListGroup>
        {componentTopic.Subgroups.map(subgroup => {

          return <Link className="cursor-pointer list-group-item list-group-item-action" to={appUserRoutes.tecRmi.tabComponentSubGroup(ident, mainGroupId, subgroup.SubgroupId, subgroup.AvailableModules[0], '')}>{subgroup.SubgroupText}</Link>
        })}
      </ListGroup>
    </React.Fragment>
  );
};

ComponentMainGroup.propTypes = {

};

export default ComponentMainGroup;